import React, { useEffect, useState } from "react";
import add from "../../images/add.svg";
import deleteIcon from "../../images/delete.png";
import RackRepository from "../../Repository/RackRepository";
import { Box, Grid, Stack } from "@mui/material";
import { Button, Container, TextField, Typography } from "@mui/material";
import DialogComponent from "../reusableComponents/Dialog";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { BodyContainer, ButtonAdd, Header, TopGrid } from "../styles";
import Search from "../components/Search";
import { DialogInput, QuantityBox, Row, RackHead, Title } from "./styles";

const schema = yup
  .object()
  .shape({
    subRack: yup.string().required("Required"),
  })
  .required();

function RackDetails(props) {
  const history = useHistory();

  const [racks, setRacks] = useState({
    loading: false,
    rack: "",
    selectedRack: "",
    sub_racks: [],
  });
  const [searchText, setSearchText] = useState("");
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    getItems();
  }, []);

  const {
    reset,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const getItems = async () => {
    setRacks((state) => ({ ...state, loading: true }));
    let { data } = await RackRepository.RackModel({
      request: {
        method: "getItemsByRack",
        data: {
          company_code: localStorage.getItem("companyCode"),
          rack_code: props.location.state.rack._id,
        },
      },
    });
    setRacks((state) => ({
      ...state,
      sub_racks: data.response.data.sub_racks,
      rack: props.location.state.rack,
      loading: false,
    }));
  };
  const addToggle = () => {
    setAddModal((state) => !state);
  };

  const deleteToggle = (item) => {
    setRacks((state) => ({ ...state, selectedRack: item }));
    setDeleteModal((state) => !state);
  };

  const Register = async (arg) => {
    const copy = racks.rack;
    copy.racks.sub_rack = [...copy.racks.sub_rack, arg.subRack];
    addToggle();
    await RackRepository.RackModel({
      request: {
        method: "updateRack",
        data: copy,
      },
    });
    toast.configure();
    toast.success("Sub Location Added Successfuly", {
      position: toast.POSITION.TOP_RIGHT,
    });
    history.push("/inventory/admin/location");
  };

  const searchedItems = () => {
    if (searchText != "") {
      const filtered = racks.sub_racks.filter((item) =>
        item.toString().toLowerCase().includes(searchText)
      );
      return filtered;
    } else {
      return racks.sub_racks;
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const deleteRack = async () => {
    const filtered = state.racks.sub_rack.filter(
      (item) => item != rack.selectedRack
    );
    let update = {
      _id: state._id,
      _rev: state._rev,
      company_code: localStorage.getItem("companyCode"),
      racks: {
        name: state.racks.name,
        sub_rack: filtered,
      },
    };

    await RackRepository.RackModel({
      request: {
        method: "updateRack",
        data: update,
      },
    });

    deleteToggle();
    toast.configure();
    toast.success("Sub Location Deleted Successfuly", {
      position: toast.POSITION.TOP_RIGHT,
    });
    history.push("/inventory/admin/location");
  };

  const goBack = () => {
    history.push("/inventory/admin/location");
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center" spacing={1}>
          <Grid item md={3} xs={12} className="ml-n-16">
            <Search
              name={"searchText"}
              text={"Search item..."}
              value={searchText}
              onChange={handleSearch}
            />
          </Grid>
          <Grid align="center" item lg={6} md={4} xs={12}>
            <Typography variant="h5" sx={{ color: "white" }}>
              {racks.rack.racks?.name}
            </Typography>
          </Grid>
          <Grid align="center" item lg={1} md={2} xs={5} className="ml-n-16">
            <ButtonAdd
              variant="contained"
              fullWidth
              onClick={goBack}
              sx={{
                textTransform: "none",
                fontSize: { md: "16px", xs: "10px" },
              }}
            >
              Back
            </ButtonAdd>
          </Grid>
          <Grid align="center" item lg={2} md={3} xs={6}>
            <ButtonAdd
              variant="contained"
              onClick={addToggle}
              sx={{
                textTransform: "none",
                fontSize: { md: "16px", xs: "10px" },
                width: { md: "100%", xs: "90%" },
              }}
            >
              Add Sub Location
              <img src={add} alt="add" />
            </ButtonAdd>
          </Grid>
        </TopGrid>
      </Header>

      <BodyContainer>
        {searchedItems()?.map((item, index) => {
          return (
            <Box key={index}>
              <RackHead>
                <Box align="center">
                  <Typography style={{ color: "white" }}>
                    {item.sub_rack_name}
                  </Typography>
                </Box>
                <Box>
                  <img
                    style={{ marginLeft: "-15px", cursor: "pointer" }}
                    src={deleteIcon}
                    alt="delete"
                    onClick={() => deleteToggle(item)}
                  />
                </Box>
              </RackHead>
              {item.items.map((subItem, index) => {
                let qty = subItem.weightType
                  ? parseFloat(subItem.weight)
                  : parseFloat(subItem.quantity);
                let itemQty = qty % 1 === 0 ? qty : qty.toFixed(3);
                return (
                  <Row>
                    <Typography sx={{ color: "#4EAF50" }}>
                      {index + 1}
                    </Typography>
                    <Typography sx={{ color: "#4EAF50" }}>
                      {subItem.item_name}
                    </Typography>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography sx={{ color: "#4EAF50" }}>
                        Quantity
                      </Typography>
                      <QuantityBox>
                        <Typography>{itemQty}</Typography>
                      </QuantityBox>
                    </Stack>
                  </Row>
                );
              })}
            </Box>
          );
        })}
      </BodyContainer>

      <DialogComponent
        title="Add Sub Location"
        open={addModal}
        onClose={addToggle}
        onClickCancel={addToggle}
        dialogContent={
          <Container>
            <Title>Create a new sub Location !</Title>
            <Typography sx={{ textAlign: "left", mt: 1 }} variant="body1">
              Location name :
            </Typography>
            <DialogInput
              fullWidth
              disabled
              variant="outlined"
              placeholder="Main Location"
              value={racks.rack.racks?.name}
            />
            <Typography sx={{ textAlign: "left", mt: 1 }} variant="body1">
              Enter sub-location name :
            </Typography>
            <DialogInput
              fullWidth
              variant="outlined"
              placeholder="Sub Location"
              {...register("subRack")}
            />
            <Typography style={{ color: "red" }}>
              {errors.subRack?.message}
            </Typography>
            <Stack direction="row" spacing={5}>
              <Button
                fullWidth
                sx={{ color: "white", background: "#8A8A8A !important" }}
                onClick={addToggle}
              >
                Cancel
              </Button>

              <Button
                fullWidth
                variant="contained"
                onClick={handleSubmit(Register)}
              >
                Add
              </Button>
            </Stack>
          </Container>
        }
      />

      <DialogComponent
        title="Delete Location"
        open={deleteModal}
        onClose={deleteToggle}
        onClickCancel={deleteToggle}
        dialogContent={
          <Container>
            <Typography style={{ color: "red" }}>
              Are you sure to want to delete!
            </Typography>

            <Stack direction="row" spacing={5}>
              <Button
                fullWidth
                sx={{ color: "white", background: "#8A8A8A !important" }}
                onClick={deleteToggle}
              >
                Cancel
              </Button>

              <Button fullWidth variant="contained" onClick={deleteRack}>
                Delete
              </Button>
            </Stack>
          </Container>
        }
      />
    </Box>
  );
}

export default RackDetails;
